<template>
  <GalleryView
    :load-gallery-media="loadMoreMedia"
    :total-gallery-media="totalEventMedia"
    :sortable="isSortable"
    @reorder="handleReorder"
    :id="'post_' + post.id"
    :is-highlight-gallery="false"
  >
    <template v-slot:header>
      <div
        style="width: 100%"
        class="d-flex justify-space-between align-center"
      >
        <div class="d-flex align-center">
          <PostAvatar
            :creator="post.creator"
            :view-context="viewContext"
            always-small
          ></PostAvatar>
          <div class="ml-4">
            <PostHeader :post="post" :view-context="viewContext" />
          </div>
        </div>
        <IconButton
          tooltip="Galerie herunterladen"
          class="ml-4"
          @click="onDownloadClick"
          :icon="mdiDownload"
        />
      </div>
    </template>
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs" />
    </template>
  </GalleryView>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue"
import GalleryView, {
  LoadGalleryMediaFunction,
} from "features/gallery/view/GalleryView.vue"
import { Post } from "suus-api"
import { eventMediaApi } from "store/api"
import PostAvatar from "components/Post/PostAvatar.vue"
import { getContextNameLong, ViewContext } from "concerns/useContextName"
import Subtitle from "components/UI/Subtitle.vue"
import PostHeader from "components/Post/PostHeader.vue"
import IconButton from "components/UI/IconButton.vue"
import { mdiDownload } from "@mdi/js"

export default defineComponent({
  name: "PostGalleryView",
  methods: { getContextNameLong },
  components: { IconButton, PostHeader, Subtitle, PostAvatar, GalleryView },
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
    viewContext: {
      type: Object as PropType<ViewContext>,
    },
  },
  setup(props, { emit }) {
    const loadMoreMedia: LoadGalleryMediaFunction = async (offset, limit) => {
      const response = await eventMediaApi.getEventMedia(
        props.post.id.toString(),
        offset,
        limit,
        "asc"
      )
      return response.data
    }

    const totalEventMedia = computed(() => {
      return props.post.event_media_count
    })

    const isSortable = computed(() => {
      return !!props.post.links.update_url
    })

    const handleReorder = async ({
      id,
      index,
    }: {
      id: number
      index: number
    }) => {
      await eventMediaApi.updateEventMedium(id.toString(), {
        index,
      })
      emit("reorder", { id, index })
    }

    const onDownloadClick = () => {
      // Set the responseType to allow our axios interceptor to handle the file download
      eventMediaApi.downloadEventMedia(props.post.id.toString(), {
        responseType: "blob",
      })
    }

    return {
      loadMoreMedia,
      totalEventMedia,
      onDownloadClick,
      mdiDownload,
      isSortable,
      handleReorder,
    }
  },
})
</script>
